import { Controller } from 'stimulus';

class ClampController extends Controller {
  static targets = ['content', 'toggleButton'];

  scrollOffset = 100;

  connect() {
    if (!this.#shouldClamp()) {
      this.toggleButtonTarget.style.display = 'none';
    }
  }

  toggle(e) {
    this.contentTarget.classList.toggle('is-open');
    e.target.textContent = this.#isOpen() ? 'Read Less' : 'Read More';

    if (!this.#isOpen()) {
      const scrollPosition =
        this.contentTarget.getBoundingClientRect().top +
        window.pageYOffset -
        this.scrollOffset;
      window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
    }
  }

  #shouldClamp() {
    this.contentTarget.classList.remove('is-clamped');
    const unclampedHeight = this.contentTarget.clientHeight;
    this.contentTarget.classList.add('is-clamped');
    const clampedHeight = this.contentTarget.clientHeight;

    return clampedHeight < unclampedHeight;
  }

  #isOpen() {
    return this.contentTarget.classList.contains('is-open');
  }
}

export default ClampController;
